/**
 * Stable DOM id on the chat card root. Lets in-panel modals (e.g.
 * `MessageFeedback`'s reason modal) portal into the card via
 * `document.getElementById`, so their `position: absolute; inset: 0`
 * backdrop aligns to the chat card itself rather than the viewport.
 *
 * Lives in its own module (not next to `ChatPanelExpanded`) because
 * the contract is cross-component — both the producer (the card
 * root) and the consumers (any in-panel modal) need to import it
 * without coupling to each other's file structure.
 */
export const CHAT_PANEL_CARD_ID = 'routine-agent-chat-panel-card';

/**
 * Width of the chat card in pixels. Shared between
 * `ChatPanelExpanded` (sets the card's `width`) and
 * `ChatPanelOverlay` (uses it in the `left: calc(100% - ...)`
 * position calc that anchors the card to the right edge). Keeping
 * one source of truth means changing the width updates both
 * surfaces in lockstep.
 */
export const CHAT_PANEL_CARD_WIDTH = 380;

/**
 * How long the chat panel can stay minimized before reopening it
 * lands the user on a fresh chat instead of the stale session. The
 * old session isn't deleted — it stays reachable via Chat history;
 * reopening past this cutoff just unbinds it (same as "New chat").
 * An in-flight turn or a pending tool-use confirmation keeps the
 * session alive regardless of elapsed time.
 */
export const CHAT_MINIMIZED_NEW_CHAT_TIMEOUT_MS = 5 * 60 * 1000;
